import axios from 'axios';

export const createSurveyApi = (data) => axios.post(`/api/projects/${data.projectId}/survey`, data);

export const getSurveyApi = (projectId) => axios.get(`/api/projects/${projectId}/survey`);

export const deleteSurveyApi = (projectId, id, data) =>
	axios.delete(`/api/projects/${projectId}/survey/${id}`, { data });

export const editSurveyApi = (data, surveyId) =>
	axios.put(`/api/projects/${data.projectId}/survey/${surveyId}`, data);

export const duplicateSurveyApi = (projectId, surveyId) =>
	axios.put(`/api/projects/${projectId}/survey/duplicate/${surveyId}`);

export const assignSurveyApi = ({ selectedProject, ...rest }) =>
	axios.post(`/api/projects/${selectedProject}/survey/assign`, { rest });

export const getAssignedSurveyApi = (projectId, surveyId) =>
	axios.get(`/api/projects/${projectId}/survey/${surveyId}`);

export const saveAnswersApi = (data) =>
	axios.post(`/api/projects/${data.projectId}/survey/${data.surveyId}/answers`, data);

export const getPurchaserProfilesApi = (selectedProject) =>
	axios.get(`/api/projects/${selectedProject}/purchaser-profiles`);

export const getPurchaserProfileByIdApi = (selectedProject, profileId) =>
	axios.get(`/api/projects/${selectedProject}/purchaser-profiles/${profileId}`);

export const deletePurchaserProfileApi = (projectId, id, contactId, data) =>
	axios.delete(`/api/projects/${projectId}/purchaser-profiles/${id}/${contactId}`, { data });

export const updateAnswersApi = (data) =>
	axios.put(`/api/projects/${data.projectId}/purchaser-profiles`, data);

export const sendUrlApi = (data) =>
	axios.post(`/api/projects/${data.selectedProject}/send-url`, data);

export const checkTokenApi = (token) => axios.post('/api/check-contact-token', token);

export const getGtkySurveyApi = (projectId) =>
	axios.get(`/api/projects/${projectId}/survey/gtky`);

export const getContactGtkyStatusApi = (projectId, contactId) =>
	axios.get(`/api/projects/${projectId}/contacts/${contactId}/gtky-status`);

export const copyToProjectSurveyApi = (projectId, surveyId, targetProjectId) =>
	axios.post(`/api/projects/${projectId}/survey/${surveyId}/copy-to-project`, { targetProjectId });

export const getAllSurveysApi = () => axios.get('/api/surveys/all');

/**
 * Ensures all required GTKY questions exist in the default survey (adds missing ones
 * with a version bump), then returns the up-to-date GTKY survey.
 * Returns { gtkySurvey: Survey | null, gtkySurveyId: string | null }.
 */
export const ensureGtkyQuestionsApi = (projectId) =>
	axios.post(`/api/projects/${projectId}/survey/gtky/ensure-questions`);

export const fetchGtkyForProject = async (projectId) => {
	const res = await ensureGtkyQuestionsApi(projectId);
	if (!res.data) return { gtkySurvey: null, gtkySurveyId: null };
	return { gtkySurvey: res.data, gtkySurveyId: res.data.id };
};

/**
 * Checks GTKY completion status for a list of contacts.
 * Returns only the contacts that still need GTKY, with existingAnswers attached.
 */
export const fetchContactsNeedingGtky = async (projectId, contacts) => {
	const statusChecks = await Promise.all(
		contacts.map((c) =>
			getContactGtkyStatusApi(projectId, c.id).then((r) => ({
				contact: c,
				hasCompletedGtky: r.data.hasCompletedGtky,
				existingAnswers: r.data.existingAnswers || null
			}))
		)
	);
	return statusChecks
		.filter((x) => !x.hasCompletedGtky)
		.map((x) => ({ ...x.contact, existingAnswers: x.existingAnswers }));
};
